import { object, string, number, date, lazy } from "yup";

export const filtersSchema = object({
  date: object({
    startDate: lazy((value) => {
      switch (typeof value) {
        case "date":
          return date().default(() => new Date());
        case "string":
          return string();
        default:
          return date().default(() => new Date());
      }
    }),
    endDate: lazy((value) => {
      switch (typeof value) {
        case "date":
          return date().default(() => new Date());
        case "string":
          return string();
        default:
          return date().default(() => new Date());
      }
    }),
  }),
  // email: string().email("Geçerli bir eposta adresi giriniz"),
  // sendTypeId: number().required("Gonderim tipi secmek zorunludur"),

});
